export default "<div [id]=\"chartdiv\" #graphWrapper style=\"width: 100%\">Graph Not Loaded</div>"